/* eslint-disable vue/attribute-hyphenation */
<!-- GRADING Photo component -->
<template>
  <md-card id="opacity" class="md-with-hover" @mouseover.native="mouseOver" @mouseleave.native="mouseLeave">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="md-layout">
        <div class="card-icon" style="margin-left: 5px; margin-top: -7px; margin-right: 0px">
          <md-icon>remove_red_eye</md-icon>
        </div>
        <div class="md-layout-item">
          <h4 class="title" style="font-weight: 400">LENS STATUS</h4>
        </div>
        <div class="md-layout md-layout-item md-alignment-center-right">
          <md-button
            v-show="addnlOPA"
            slot="title"
            class="md-button md-warning md-sm"
            style="margin-top: 15px; margin-right: 10%"
            @click.prevent="toggleImgBox"
          >
            ADD'L IMAGES
          </md-button>
        </div>
      </div>
    </md-card-header>

    <md-card-content>
      <!-- ROW HEADINGS -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: center">
        <div class="md-layout-item">
          <label for="diagOpaOD" style="font-weight: bold">RIGHT</label>
        </div>

        <div class="md-layout-item">
          <label for="diagOpaOS" style="font-weight: bold">LEFT</label>
        </div>
      </div>

      <hr style="width: 98%" />

      <!--IMAGE-->
      <div class="md-layout-item" style="padding: 2px; text-align: center; margin-left: -20px">
        <drop class="drop" @drop="handleDrop">
          <img
            v-if="noOpaODOS"
            :style="imgStyle"
            name="paceholder"
            src="@/assets/img/imageNA.jpg"
            height="100px"
            width="auto"
          />

          <img
            v-else
            :src="imgOpaODOS_Url"
            :style="imgStyle"
            name="imgOpa"
            alt="Opacity Photo"
            height="400px;"
            width="auto"
            @click="opaModal(imgOpaODOS_Url)"
          />
        </drop>
      </div>

      <hr style="width: 98%" />

      <!-- ROW LISTBOXES -->
      <div class="md-layout md-gutter md-alignment-space-around-center" style="margin-left: -15px">
        <findings-search :section="Section" :sectionName="SectionName" :mState="mState" />

        <hr style="margin: 0; padding: 0" />
      </div>
    </md-card-content>

    <hr />

    <!-- MODAL LARGE IMAGE -->
    <modal v-if="winModal" md-dynamic-height>
      <template slot="header">
        <div class="md-layout md-alignment-center-right">
          <div class="md-layout-item"></div>
          <div class="md-layout-item md-alignment-top-right" align="right">
            <md-icon class="exit-icon" style="color: red" @click.native="winModal = false">cancel</md-icon>
          </div>
        </div>
      </template>
      <template slot="body">
        <div v-if="OpaModal" class="md-layout" @click="winModal = false">
          <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: Left">
            <div class="md-layout-item">
              <img :src="ModalImg" />
            </div>

            <div class="md-layout-item md-size-30" style="text-align: center">
              <span><b>Lens Opacity Cataract Scale</b></span>
              <img src="@/assets/img/LOCS.png" />
            </div>
          </div>
        </div>
      </template>
    </modal>
  </md-card>
</template>

<script>
import { mapGetters } from "vuex"
import { Modal } from "@/components"
import { bus } from "@/main"
import FindingsSearch from "@/components/GlobeChek/screening/findings/Top5Findings"
export default {
  name: "PhotoOpacity",
  components: {
    "findings-search": FindingsSearch,
    Modal
  },
  props: {},
  data() {
    return {
      Section: "Opacity",
      SectionName: "Lens Status",
      LOCS: "@/assets/img/LOCS.png",
      replaceImgOD: null,
      mState: false,
      ModalImg: "",
      normal: null,
      normalStyle: "",
      winModal: false,
      OpaModal: false,
      imgStyle: "",
      imgStyleInactive: "filter:grayscale(100%);",
      imgStyleActive: ""
    }
  },
  computed: {
    ...mapGetters(["opacityPhoto", "imagesPath", "addnlOPA", "getImageUrlByIds"]),

    noOpaODOS() {
      if (this.replaceImgOD) {
        return false
      } else {
        if (this.getImageUrlByIds("opacity", ["OPAODOS"]) == false) {
          return true
        }
      }
    },
    imgOpaODOS_Url() {
      if (this.replaceImgOD) {
        return this.replaceImgOD
      } else {
        return this.getImageUrlByIds("opacity", ["OPAODOS"])
      }
    }
  },
  mounted: function () {
    this.imgStyle = this.imgStyleInactive
  },
  methods: {
    toggleImgBox() {
      bus.$emit("toggleImgBox", "OPA")
    },
    mouseOver: function () {
      try {
        this.mState = true
        this.imgStyle = this.imgStyleActive
        this.normalStyle = false
      } catch (error) {
        console.log(error)
      }
    },
    mouseLeave: function () {
      try {
        this.mState = false
        this.imgStyle = this.imgStyleInactive
        this.normalStyle = "disabled"
      } catch (error) {
        console.log(error)
      }
    },
    clearModal() {
      this.winModal = false
      this.OpaModal = false
      this.FindingModal = false
    },
    opaModal: function (img) {
      this.clearModal()
      this.ModalImg = img
      this.winModal = true
      this.OpaModal = true
    },
    handleDrop(data) {
      //console.log(`You droppped: ${JSON.stringify(data)}`);
      this.replaceImgOD = data.url
      this.$store.dispatch("SetImgReplace", { OPAODOS: data.url })
      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss" scoped>
#opacity {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.values {
  font-size: 0.7rem;
  padding: 0px;
  margin-top: 10px;
  line-height: 1.4em;
  font-weight: 200;
}

.values2 {
  padding: 0px;
  font-weight: 350;
  font-size: 12pt;
  line-height: 14px;
  align-content: start;
}

.mswitch {
  color: rgba(46, 46, 46, 0.8) !important;
  font-size: 0.8rem;
}

.mswitch-normal {
  color: rgba(0, 98, 211, 0.8) !important;
  font-size: 0.95rem;
}

.drag,
.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 0px;
  background: #ccc;
  position: relative;
  padding: 0px;
  text-align: center;
  vertical-align: top;
}

.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
}

.drop {
  background: #eee;
  border-top: 2px solid #ccc;
  border-left: 2px solid #ccc;
}
</style>
